var omjs                = require('./omjs.project');
var consts              = require('consts');
var viewFabric          = require("./View/viewFabric");
var View                = require("./View/View");
var Layer               = require("./View/Layer");
var UTFGridLayer        = require("./View/UTFGrid");
var LayerCollection     = require("./View/LayerCollection");
var TileLayer           = require("./View/TileLayer");
var VectorLayer         = require("./View/VectorLayer");
var ImageLayer          = require("./View/ImageLayer");
var MVTLayer            = require("./View/MVTLayer");
var OmsVectorLayer      = require("./View/OmsVectorLayer");
var OmsCategoryLayer    = require("./View/OmsCategoryLayer");
var OmsChartsLayer      = require("./View/OmsChartsLayer");
var OmsVectorFeatureLayer      = require("./View/OmsVectorFeatureLayer");
var Choropleth          = require("./View/Choropleth");
var Widget              = require("./View/Widget/Widget");
var Button              = require("./View/Widget/Button");
var ButtonGroup         = require("./View/Widget/ButtonGroup");
var ZoomControl         = require("./View/Widget/ZoomControl");
var DistanceButton      = require("./View/Widget/DistanceButton");
var RadiusButton   	    = require("./View/Widget/RadiusButton");
var PointButton   	    = require("./View/Widget/PointButton");
var AreaButton          = require("./View/Widget/AreaButton");
var SidePanel           = require("./View/Widget/SidePanel");
var ModalMessage        = require("./View/Widget/ModalMessage");
var LayersTree          = require("./View/Widget/LayersTree/LayersTree");
var Window              = require("./View/Widget/Window/Window");
var Panel               = require("./View/Widget/Panel");
var Legend              = require("./View/Widget/Legend/Legend");
var LegendGroup         = require("./View/Widget/LegendGroup");
var BubbleLegend        = require("./View/Widget/Legend/BubbleLegend");
var ThematicLegend      = require("./View/Widget/Legend/ThematicLegend");
var CategoryLegend      = require("./View/Widget/Legend/CategoryLegend");
var ol                  = require("openlayers");
var MarkerLayer         = require("./View/MarkerLayer");
var SearchBar           = require("./View/Widget/SearchBar/SearchBar");
var SearchBarExt        = require("./View/Widget/SearchBarExt/SearchBarExt");
var DropDown		    = require("./View/Widget/DropDown");
var LabelButton		    = require("./View/Widget/LabelButton");
var MeasureToolChanger  = require("./View/Widget/MeasureToolChanger");
var PublicMapDraw       = require("./View/PublicMapDraw");

omjs.ol       = ol;
omjs.initView = viewFabric;

omjs.View                  		= View;
omjs.View.Layer            		= Layer;
omjs.View.LayerCollection  		= LayerCollection;
omjs.View.TileLayer        		= TileLayer;
omjs.View.VectorLayer      		= VectorLayer;
omjs.View.ImageLayer      		= ImageLayer;
omjs.View.MVTLayer      		= MVTLayer;
omjs.View.OmsVectorLayer   		= OmsVectorLayer;
omjs.View.OmsCategoryLayer 		= OmsCategoryLayer;
omjs.View.OmsChartsLayer   		= OmsChartsLayer;
omjs.View.MarkerLayer      		= MarkerLayer;
omjs.View.Choropleth       		= Choropleth;
omjs.View.UTFGridLayer     		= UTFGridLayer;
omjs.View.OmsVectorFeatureLayer = OmsVectorFeatureLayer;
omjs.View.PublicMapDraw         = PublicMapDraw;
		
omjs.Widget                		= Widget;
omjs.Widget.Button         		= Button;
omjs.Widget.ButtonGroup    		= ButtonGroup;
omjs.Widget.DistanceButton 		= DistanceButton;
omjs.Widget.RadiusButton 		= RadiusButton;
omjs.Widget.PointButton 		= PointButton;
omjs.Widget.AreaButton     		= AreaButton;
omjs.Widget.SidePanel      		= SidePanel;
omjs.Widget.LayersTree     		= LayersTree;
omjs.Widget.Window         		= Window;
omjs.Widget.Panel          		= Panel;
omjs.Widget.Legend         		= Legend;
omjs.Widget.LegendGroup    		= LegendGroup;
omjs.Widget.BubbleLegend   		= BubbleLegend;
omjs.Widget.ThematicLegend 		= ThematicLegend;
omjs.Widget.CategoryLegend 		= CategoryLegend;
omjs.Widget.ModalMessage   		= ModalMessage;
omjs.Widget.ZoomControl    		= ZoomControl;
omjs.Widget.SearchBar      		= SearchBar;
omjs.Widget.SearchBarExt   		= SearchBarExt;
omjs.Widget.DropDown	   		= DropDown;
omjs.Widget.LabelButton	   		= LabelButton;
omjs.Widget.MeasureToolChanger 	= MeasureToolChanger;

omjs.baseMapType = {
    'MAP'     : 1,
    'URL'     : 2,
    'EXTERNAL': 3
};

omjs.C = consts;


module.exports = omjs;



//////////////////
// WEBPACK FOOTER
// ./src/omjs.full.js
// module id = 0
// module chunks = 0